var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.computedDivClass},[_c('v-skeleton-loader',{attrs:{"loading":_vm.loading,"type":_vm.type}},[_c('v-card',_vm._b({class:_vm.computedClass,attrs:{"outlined":"","elevation":"0"}},'v-card',_vm.$attrs,false),[_vm._t("header"),_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }